/**
 * Panel definitions for forward/oil commodity
 * Based on ice-cals-brent-crude dataset
 */
export const forwardOilPanels = [
  // First row: 2 panels side-by-side (12 cols each)
  {
    id: 'brent-forward-curve',
    type: 'datasetChart',
    datasetId: 'ice-cals-brent-crude',
    visualizationId: 'cals-brent-crude-forward-curve',
    labelOverrides: { descriptionKey: 'dashboard_panels.oil_forward_curve' },
    gridPos: { x: 0, y: 0, w: 8, h: 14 },
  },
  {
    id: 'brent-monthly-settlements',
    type: 'datasetChart',
    datasetId: 'ice-cals-brent-crude',
    visualizationId: 'cals-brent-crude-monthly-settlements',
    gridPos: { x: 8, y: 0, w: 8, h: 14 },
  },
  {
    id: 'brent-front-month',
    type: 'datasetChart',
    datasetId: 'ice-cals-brent-crude',
    visualizationId: 'cals-brent-crude-front-month-daily',
    gridPos: { x: 16, y: 0, w: 8, h: 14 },
  },
];

export const forwardOilSyncGroups = [
  {
    id: 'oil-first-row',
    global: false,
    ids: ['brent-forward-curve', 'brent-monthly-settlements', 'brent-front-month'],
    syncAxes: { y: true },
  },
];
